export default [
  {
    path: '/admin/trader/profit-strategies',
    name: 'ProfitStrategies',
    component: () => import('@/views/Admin/Trader/ProfitStrategies/Index.vue'),
    meta: {
      pageTitle: 'Kazanç Stratejileri',
      breadcrumb: [
        { text: 'Trader', active: false },
        { text: 'Kazanç Stratejileri', active: true },
      ],
      resource: 'targets.list',
      action: 'read',
    },
  },
]
